<ws-modal-wrapper
    headerLabel="Browse Columns"
    [acceptLabel]="'Add' + (columnsToAdd.length ? ' ' + columnsToAdd.length : '')"
    [disableSave]="!columnsToAdd.length"
    auxButtonLabel="Clear Selection"
    [excludeModalStyling]="true"
    (save)="addColumns()"
    (cancel)="closeModal()"
    (auxButton)="clearSelection()"
>
    <tabset class="column-picker-tabs">
        @for (category of columnCategories; track category) {
            <tab (selectTab)="tabSelected(category)" [ngClass]="{ 'browse-category-disabled': category.disabled }">
                <ng-template tabHeading>
                    {{ category.categoryName }}
                    @if (category.totalCheckedCount) {
                        <span class="badge">{{ category.totalCheckedCount }}</span>
                    }
                </ng-template>
                <tabset [vertical]="true" type="pills" class="column-subcategories">
                    <tab>
                        <ng-template tabHeading>
                            General<span class="badge" [class.invisible]="!category.checkedCount">{{
                                category.checkedCount
                            }}</span>
                        </ng-template>
                        <div [hidden]="areColumnsHidden" class="browse-columns-height category-column">
                            @if (category.disabled) {
                                <div
                                    class="ws-flex-container-horizontal ws-flex-justify-content-center browse-columns-height"
                                >
                                    @if (!isTaskTypeSpecialCase) {
                                        @if (offendingColumns?.length > 0) {
                                            <div>
                                                <h4
                                                    >This category is disabled because the following fields are already
                                                    included:</h4
                                                >
                                                <ul>
                                                    @for (col of offendingColumns; track col) {
                                                        <li>{{ col.typeAheadName || col.displayName }}</li>
                                                    }
                                                </ul>
                                            </div>
                                        } @else {
                                            <div>
                                                <h4>All columns in this category are already included.</h4>
                                            </div>
                                        }
                                    }
                                    @if (isTaskTypeSpecialCase) {
                                        <div>
                                            <h4
                                                >This category is disabled because the
                                                <strong>{{ selectedTaskType.name }}</strong> task type is selected.</h4
                                            >
                                        </div>
                                    }
                                </div>
                            } @else {
                                @for (column of category.columns; track column) {
                                    <div class="checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                [checked]="isColumnChecked(column)"
                                                (change)="columnClicked(column, $event)"
                                                [disabled]="column.disabled"
                                            />
                                            {{ column.displayName }}
                                        </label>
                                    </div>
                                }
                            }
                        </div>
                        <div
                            style="height: 500px; width: 100%; background-color: #fff"
                            [hidden]="!areColumnsHidden"
                        ></div>
                    </tab>
                    @for (subcategory of category.subcategories; track subcategory) {
                        <tab
                            [ngClass]="{ 'browse-category-disabled': subcategory.disabled }"
                            [customClass]="'text-nowrap'"
                            (selectTab)="tabSelected(subcategory)"
                        >
                            <ng-template tabHeading>
                                {{ subcategory.categoryName }}
                                <span class="badge" [class.invisible]="!subcategory.checkedCount">{{
                                    subcategory.checkedCount
                                }}</span>
                            </ng-template>
                            @if (subcategory.disabled) {
                                <div class="browse-columns-height">
                                    <h4
                                        >This subcategory is disabled because the following fields are already
                                        included:</h4
                                    >
                                    <ul>
                                        @for (col of offendingColumns; track col) {
                                            <li>{{ col.typeAheadName || col.displayName }}</li>
                                        }
                                    </ul>
                                </div>
                            }
                            @if (!subcategory.disabled) {
                                <div class="browse-columns-height category-column">
                                    @for (column of subcategory.columns; track column) {
                                        <div class="checkbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    [checked]="isColumnChecked(column)"
                                                    (change)="columnClicked(column, $event)"
                                                    [disabled]="column.disabled"
                                                />
                                                {{ column.displayName }}
                                            </label>
                                        </div>
                                    }
                                </div>
                            }
                        </tab>
                    }
                </tabset>
            </tab>
        }
    </tabset>
</ws-modal-wrapper>
